import { API, Storage, graphqlOperation } from 'aws-amplify';

import * as mutations from '../../../graphql/mutations';
import * as queries from '../../../graphql/queries';

const STORAGE_LEVEL = 'public';
const STORAGE_PREFIX = 'dqf-additional';

const generateUuid = () =>
  'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    // eslint-disable-next-line no-bitwise
    const r = (Math.random() * 16) | 0;
    // eslint-disable-next-line no-bitwise
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });

export const fetchAdditionalDocuments = async dqfId => {
  try {
    const response = await API.graphql(
      graphqlOperation(queries.listAdditionalDocumentsByDqfId, {
        driverQualificationAdditionalDocumentsId: dqfId,
      }),
    );
    return response.data?.listAdditionalDocumentsByDqfId?.items ?? [];
  } catch (e) {
    console.error('fetchAdditionalDocuments error', e);
    return [];
  }
};

export const uploadAdditionalDocument = async (dqfId, file, uploadedByEmail, uploadedByFullName) => {
  const uuid = generateUuid();
  const storageKey = `${STORAGE_PREFIX}/${dqfId}/${uuid}-${file.name}`;

  try {
    await Storage.put(storageKey, file, {
      level: STORAGE_LEVEL,
      contentType: file.type || 'application/octet-stream',
    });
  } catch (e) {
    console.error('uploadAdditionalDocument S3 error', e);
    return null;
  }

  try {
    const response = await API.graphql(
      graphqlOperation(mutations.createDriverQualificationAdditionalDocuments, {
        input: {
          driverQualificationAdditionalDocumentsId: dqfId,
          documentName: storageKey,
          originalFileName: file.name,
          uploadedByEmail,
          uploadedByFullName,
        },
      }),
    );
    return response.data?.createDriverQualificationAdditionalDocuments ?? null;
  } catch (e) {
    console.error('uploadAdditionalDocument GraphQL error', e);
    // S3 upload succeeded but record creation failed — clean up the orphaned file
    try {
      await Storage.remove(storageKey, { level: STORAGE_LEVEL });
    } catch (removeError) {
      console.error('uploadAdditionalDocument S3 cleanup error', removeError);
    }
    return null;
  }
};

export const deleteAdditionalDocument = async (documentId, storageKey) => {
  try {
    await API.graphql(
      graphqlOperation(mutations.deleteDriverQualificationAdditionalDocuments, {
        input: { id: documentId },
      }),
    );
  } catch (e) {
    console.error('deleteAdditionalDocument GraphQL error', e);
    return false;
  }

  try {
    await Storage.remove(storageKey, { level: STORAGE_LEVEL });
  } catch (e) {
    console.error('deleteAdditionalDocument S3 error', e);
    // Record is gone from DB so UI is consistent; S3 file leaks but is unreachable
  }

  return true;
};

export const getAdditionalDocumentUrl = async storageKey => {
  try {
    return await Storage.get(storageKey, {
      level: STORAGE_LEVEL,
      expires: process.env.REACT_APP_AMPLIFY_STORAGE_GET_EXPIRES,
      download: false,
    });
  } catch (e) {
    console.error('getAdditionalDocumentUrl error', e);
    return null;
  }
};
